// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-container.MuiGrid-root {
  min-height: 100vh;
}

.sidebar-container.MuiContainer-root {
  height: 100%;
  background-color: var(--primary-color);
  color: #fff;
  padding: 0;
}
.sidebar-options {
  margin-left: 30px !important;
}
.sidebar.MuiContainer-root {
  background-color: var(--primary-color);
  color: #fff;
  height: 100%;
  padding: 0;
}

.sidebar-header.MuiTypography-root {
  font-size: 28px;
  text-align: center;
  padding: 12px;
  background-color: var(--secondary-color);
}

.sidebar-treeview.MuiTreeView-root {
  padding: 1rem;
}

.sidebar-treeview .MuiTreeItem-content {
  padding: 6px 0px !important;
}

.menu-button.MuiIconButton-root {
  display: none;
}

.toolbar.MuiToolbar-root {
  min-height: 68px;
  justify-content: flex-end;
}

.logout-button.MuiButton-root {
  color: #fff;
  background-color: var(--secondary-color);
}

@media screen and (max-width: 600px) {
  .sidebar-container.MuiContainer-root {
    display: none;
  }

  .sidebar-drawer .MuiDrawer-paper {
    min-width: 60vw;
    height: 100%;
    background-color: var(--primary-color);
    color: #fff;
    padding: 0;
  }

  .menu-button.MuiIconButton-root {
    display: unset;
    position: absolute;
    transform: translate(50%, 50%);
    z-index: 100;
    color: #fff;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/side-bar/style.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,sCAAsC;EACtC,WAAW;EACX,UAAU;AACZ;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,sCAAsC;EACtC,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,sCAAsC;IACtC,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,8BAA8B;IAC9B,YAAY;IACZ,WAAW;EACb;AACF","sourcesContent":[".main-container.MuiGrid-root {\n  min-height: 100vh;\n}\n\n.sidebar-container.MuiContainer-root {\n  height: 100%;\n  background-color: var(--primary-color);\n  color: #fff;\n  padding: 0;\n}\n.sidebar-options {\n  margin-left: 30px !important;\n}\n.sidebar.MuiContainer-root {\n  background-color: var(--primary-color);\n  color: #fff;\n  height: 100%;\n  padding: 0;\n}\n\n.sidebar-header.MuiTypography-root {\n  font-size: 28px;\n  text-align: center;\n  padding: 12px;\n  background-color: var(--secondary-color);\n}\n\n.sidebar-treeview.MuiTreeView-root {\n  padding: 1rem;\n}\n\n.sidebar-treeview .MuiTreeItem-content {\n  padding: 6px 0px !important;\n}\n\n.menu-button.MuiIconButton-root {\n  display: none;\n}\n\n.toolbar.MuiToolbar-root {\n  min-height: 68px;\n  justify-content: flex-end;\n}\n\n.logout-button.MuiButton-root {\n  color: #fff;\n  background-color: var(--secondary-color);\n}\n\n@media screen and (max-width: 600px) {\n  .sidebar-container.MuiContainer-root {\n    display: none;\n  }\n\n  .sidebar-drawer .MuiDrawer-paper {\n    min-width: 60vw;\n    height: 100%;\n    background-color: var(--primary-color);\n    color: #fff;\n    padding: 0;\n  }\n\n  .menu-button.MuiIconButton-root {\n    display: unset;\n    position: absolute;\n    transform: translate(50%, 50%);\n    z-index: 100;\n    color: #fff;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
